import * as React from 'react';

import { DefaultAppProps } from '../App';
import { IsPconCatalog } from '../DefaultValues';
import { ViewContainer } from './ViewContainer';

import { makeStyles, MakeStylesHook } from '@egr/xbox/utils/tss-react';
import { ios } from '@egr/xbox/utils/UserAgent';

const useViewStyles: MakeStylesHook<'root'> = makeStyles({ name: 'ViewRoot' })({
    root: {
        position: 'absolute',
        width: '100%',
        height: IsPconCatalog ? 'calc(100vh - 130px)' : '100vh',
        overflow: 'hidden',
        top: IsPconCatalog ? 80 : 0,
    }
});

export const ViewRoot: React.FC<DefaultAppProps> = React.memo(
    (props: React.PropsWithChildren<DefaultAppProps>) => {
        const { classes } = useViewStyles();
        const [containerHeight, setHeight] = React.useState(window.innerHeight);
        const onResize: () => void = React.useCallback(
            () => { setHeight(window.innerHeight); },
            []
        );

        React.useEffect(
            () => {
                if (!ios) {
                    return;
                }
                window.addEventListener('resize', onResize);
                return () => { window.removeEventListener('resize', onResize); };
            }
        );

        const height: number = IsPconCatalog ? containerHeight - 130 : containerHeight;

        return (
            <div className={classes.root} style={ios ? { height} : undefined}>
                <ViewContainer app={props.app}>
                    {props.children}
                </ViewContainer>
            </div>
        );
    }
);